import { render, staticRenderFns } from "./CallNew.vue?vue&type=template&id=3fb39279"
import script from "./CallNew.vue?vue&type=script&lang=js"
export * from "./CallNew.vue?vue&type=script&lang=js"
import style0 from "./CallNew.vue?vue&type=style&index=0&id=3fb39279&prod&lang=stylus&sc=true&oped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports